import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const isExpiredDate = (endDate: string | Dayjs) => {
  const end = dayjs(endDate).startOf('day');
  const now = dayjs(dayjs().format('YYYY-MM-DD'));

  const diff = end.diff(now, 'day');

  const isExpired = diff <= 0;
  const isPreExpired = diff <= 3;

  return { isExpired, isPreExpired, diff };
};
